module.exports = __webpack_public_path__ + "img/2.5c3da9a9.png";